// @ts-check
import React from 'react'
import { Label } from '../Label/Label'
import { Error } from '../Error/Error'
import styles from './style.css'
import { validateUTF8StringLength } from '../../utils/validateUTFStringLength'

/**
 * @param {{
 * label: string,
 * error: string,
 * showLabelAsPlaceholder?: boolean,
 * valid: boolean,
 * info?: string,
 * name: string,
 * placeholder?: string,
 * value: string,
 * onChange?: {(event: React.ChangeEvent): void},
 * onBlur?: {(event: React.FocusEvent): void},
 * disabled?: boolean,
 * required?: boolean,
 * maxLength?: number
 * }} props
 */
const TextArea = ({
  label,
  error,
  showLabelAsPlaceholder,
  valid,
  info,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  required,
  maxLength
}) => {
  /**
   * @type {string}
   */
  const htmlFor = label
  const className = error.length ? styles.textAreaInvalid : ''
  const onChangeHandler = (event) => {
    const { target: { value } } = event
    if (maxLength) {
      if (validateUTF8StringLength(value, maxLength)) {
        onChange(event)
      }
    } else {
      onChange(event)
    }
  }
  return (
    <div className={styles.field}>
      {!showLabelAsPlaceholder && (
        <Label htmlFor={htmlFor} value={label} valid={valid} info={info} />
      )}
      <textarea
        className={`${styles.textArea} ${className}`}
        id={htmlFor}
        name={name}
        placeholder={showLabelAsPlaceholder ? label : placeholder}
        value={value}
        onChange={onChangeHandler}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        autoComplete='nope'
        rows={4}
      />
      <Error value={error} />
    </div>
  )
}

TextArea.defaultProps = {
  type: 'text',
  placeholder: '',
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
  required: false,
  maxLength: 250
}

export { TextArea }
